import React from 'react';
import ApexChart from 'react-apexcharts';
export default function LoungeStatsBlock({
  options,
  series
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "u-full-width"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-paper u-padding-top-0\r no-horizontal-padding"
  }, /*#__PURE__*/React.createElement(ApexChart, {
    options: options,
    series: series,
    type: "bar",
    height: 350
  })));
}
